import React from 'react'
import styles from './loader.module.css'

const loader = () => {
  return (
    <div className={styles.loader}></div>
  )
}

export default loader